import { Box, Divider, Flex, Text, Title } from "@mantine/core";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
} from "recharts";
import { PDFPage } from "./PDFPage";
import useReportStore from "../../../store/useReportStore";

interface Strength {
  subject: string;
  value: number;
  color: string;
  description: string;
}

const generateRadarData = (strengths: Strength[]) => {
  return strengths.map((item) => ({
    subject: item.subject,
    A: item.value,
    fullMark: 100,
  }));
};

export const StrengthsDerivedFromResumePDF = () => {
  const { report } = useReportStore();

  // Перевіряємо наявність даних і трансформуємо їх
  const strengthsData = report?.strengths || [];

  // Перетворюємо дані зі стору в зручний формат для компонента
  const strengths: Strength[] = strengthsData.data.map((strength, index) => ({
    subject: strength.title,
    value: strength.percentage,
    color:
      index % 5 === 0
        ? "#05D8D2"
        : index % 5 === 1
        ? "#3A8BD9"
        : index % 5 === 2
        ? "#6F40E2"
        : index % 5 === 3
        ? "#A64DD7"
        : "#DE57CC",
    description: strength.description,
  }));

  const data = generateRadarData(strengths);

  return (
    <PDFPage padding>
      <Title size={48} mb={8}>
        {strengthsData?.mark_down
          ? strengthsData?.mark_down.replace("##", "")
          : ""}
      </Title>
      <Text mb={80} size="28px" lh="42px" c="dimmed">
        {strengthsData?.explanation
          ? strengthsData?.explanation
          : ""}
      </Text>
      <Flex justify="center">
        <RadarChart
          cx="50%"
          cy="50%"
          outerRadius="80%"
          width={900}
          height={422}
          data={data}
        >
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#05D8D2" stopOpacity={1} />
              <stop offset="50%" stopColor="#6F40E2" stopOpacity={1} />
              <stop offset="100%" stopColor="#DE57CC" stopOpacity={1} />
            </linearGradient>
          </defs>
          <PolarGrid />
          <PolarAngleAxis
            dataKey="subject"
            tick={{ fontSize: 22, fontWeight: "bold", fill: "#000" }}
          />
          {/* <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} /> */}
          <Radar
            name="Strengths"
            dataKey="A"
            stroke="#8884d8"
            fill="url(#colorUv)"
            fillOpacity={0.6}
            dot={{ stroke: "#6F40E2", fill: "#6F40E2", strokeWidth: 2, r: 3 }}
          />
        </RadarChart>
      </Flex>
      <Box mt={80}>
        {strengths.map((strength, index) => (
          <div key={index}>
            <Flex justify="space-between" mb={8}>
              <Text fw="bold" size="20px">
                {strength.subject}
              </Text>
              <Text fw="bold" size="20px" c={strength.color}>
                {strength.value}%
              </Text>
            </Flex>
            <Text size="20px" lh="30px" mb={8}>
              {strength.description}
            </Text>
            {index < strengths.length - 1 && <Divider size="2px" mb={8} />}
          </div>
        ))}
      </Box>
    </PDFPage>
  );
};
